// Framework registry. Adding a new framework:
//   1. Create `./<id>.framework.ts` exporting a RegisteredFramework named
//      after the framework (e.g. `NIST_CSF`).
//   2. Import and push it into FRAMEWORKS below.
//   3. Run `pnpm validate:mappings`.
//
// The validator errors if a `*.framework.ts` file exists but isn't
// registered, so drift is caught in CI.
//
// Empty for v1: this app ships without an external cross-reference catalog
// (an OWASP/MITRE-style taxonomy for AI-era infrastructure defense doesn't
// yet exist the way it does for LLM/agentic risk). Every threat category in
// modules/mappings/threat-categories.ts is marked `operational: true`, which
// exempts every threat from the "must map to a framework" validator rule, so
// an empty registry here is a supported, intentional state — not a gap to
// silently work around later.

import type { RegisteredFramework } from "../types";

export const FRAMEWORKS: readonly RegisteredFramework[] = [];
